import React, { useRef, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useDispatch, useSelector } from "react-redux";
import { setIsDark } from "../../../Toolkit/Slices/FunctionSlice";
import GradientBtn from "../../Common/GradientBtn/GradientBtn";

export default function Navbar() {
    const navi = useNavigate();
    const nav = useRef();
    const dispatch = useDispatch();
    const slice = useSelector(state => state.functionslice.value);
    const [menuOpen, setMenuOpen] = useState(false);

    const handleMenu = () => {
        if (window.innerWidth <= 768) {
            setMenuOpen(prev => !prev);
            console.log(menuOpen)
        }
    };

    // const closeMenu = () => {
    //     if (window.innerWidth <= 768) {
    //         setMenuOpen(false);
    //     }
    // };


    React.useEffect(() => {
        if (!slice.isDark) {
            document.body.classList.add("light-mode");
        } else {
            document.body.classList.remove("light-mode");
        }
    }, [slice.isDark]);
    const handleLogoClick = () => {
        window.scrollTo(0, 0);
        navi("/");
    }
    return (
        <>
            <nav className="navbar">
                {/* Shared Gradient Definition for GradientBtn */}
                <svg width="0" height="0" style={{ position: 'absolute', pointerEvents: 'none' }}>
                    <defs>
                        <linearGradient id="gradBorder" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#8CC63F" />
                            <stop offset="100%" stopColor="#69C25C" />
                        </linearGradient>
                    </defs>
                </svg>
                <Link to="/" onClick={handleLogoClick}>
                    <img
                        className="navbar-logo"
                        src={!slice.isDark ? "/Images/Icons/logo-green.svg" : "/Images/Icons/logo.svg"}
                        alt="logo"
                    />
                </Link>

                <div className="nav-links">
                    <Link to="/product" className="nav-link">
                        Products
                    </Link>
                    <Link to="/gallery" className="nav-link">
                        Gallery
                    </Link>
                    <Link to="/team" className="nav-link">
                        Team
                    </Link>
                    <Link to="/casestudy" className="nav-link">
                        Deployments
                    </Link>
                    <Link to="/contact" className="nav-link">
                        Contact
                    </Link>
                </div>

                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>


                    <div className="navbar-theme-mode" onClick={() => { dispatch(setIsDark(!slice.isDark)) }}>
                        <div className={`navbar-theme-icons ${slice.isDark && "theme-transition"}`}>
                            <img className="navbar-theme-icon" alt="" src="/Images/Icons/sun.svg" />
                            <img className="navbar-theme-icon" alt="" src="/Images/Icons/moon.svg" />
                        </div>
                    </div>

                    <img
                        className="navbar-mobile-menu-icon"
                        src="/Images/Icons/menu.svg"
                        alt="menu"
                        onClick={handleMenu}
                    />
                </div>
            </nav>
            <section
                className={`navbar-open${menuOpen ? " open" : ""}`}
                ref={nav}
                style={menuOpen ? { top: "0" } : { top: "-50vh" }}
            >
                <div>
                    <img
                        className="navbar-logo"
                        src="/Images/Icons/logo-green.svg"
                        alt="logo"
                    />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <Link to="/contact">
                            <GradientBtn className='bookdemo-mobile'>Book a Demo</GradientBtn>
                        </Link>

                        <img
                            className="navbar-menu-close"
                            src="/Images/Icons/close_black.svg"
                            alt="close"
                            onClick={handleMenu}
                            style={{ height: "24px", width: "24px", cursor: "pointer", position: 'static' }}
                        />
                    </div>
                </div>
                <div className="nav-links">
                    <Link to="/product" className="nav-link" onClick={handleMenu}>
                        Products
                    </Link>
                    <Link to="/gallery" className="nav-link" onClick={handleMenu}>
                        Gallery
                    </Link>
                    <Link to="/casestudy" className="nav-link" onClick={handleMenu}>
                        Deployments
                    </Link>
                    <Link to="/team" className="nav-link" onClick={handleMenu}>
                        Teams
                    </Link>
                    <Link to="/contact" className="nav-link" onClick={handleMenu}>
                        Contact
                    </Link>
                </div>
            </section>
            <Outlet />
        </>
    )
}